<template>
  <div :class="{ 'useful-storage-cards': isMiringuava }">
    <v-row>
      <v-col cols="12" md="9">
        <v-row>
          <v-col v-if="isMiringuava" v-bind="hydrologicalCardColumns">
            <v-card class="primary darken-1">
              <v-row class="ml-2">
                <v-col cols="12" class="ml-0 mr-2">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                  <span style="color: lightgrey; font-size: small">Atualizado em {{ usefulStorage ? usefulStorage.updated : '##/##/####' }}</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="secondary" class="mb-2">mdi-water-percent</v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">
                Armazenamento útil (%)
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="medium" right v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                  </template>
                  <span>Volume atual em relação ao volume útil.</span>
                </v-tooltip>
              </v-card-subtitle>
              <v-card-text>
                <v-row v-if="!usefulStorage">
                  <v-col cols="3">
                    <v-icon color="orange" right>mdi-information-outline</v-icon>
                  </v-col>
                  <v-spacer />
                  <v-col cols="9">
                    <span style="color: orange">Os dados de armazenamento útil estão indisponíveis no momento.</span>
                  </v-col>
                </v-row>
                <v-row v-else class="white--text">
                  <v-col cols="12">
                    <strong class="display-1 font-weight-bold">
                      {{ formatNumber(usefulStorage.value) }}
                      <span class="font-weight-thin title">%</span>
                    </strong>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-bind="hydrologicalCardColumns">
            <v-card class="primary darken-1">
              <v-row class="ml-2">
                <v-col cols="12" class="ml-0 mr-2">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                  <span v-if="volume" style="color: lightgrey; font-size: small">Atualizado em {{ volume.data }}</span>
                  <span v-else style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="secondary" class="mb-2">
                  mdi-database-outline
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Volume</v-card-subtitle>
              <v-card-text>
                <v-row v-if="!volume">
                  <v-col cols="3">
                    <v-icon color="orange" right>mdi-information-outline</v-icon>
                  </v-col>
                  <v-spacer/>
                  <v-col cols="9">
                    <span style="color: orange">Os dados de volume estão indisponíveis no momento.</span>
                  </v-col>
                </v-row>
                <v-row v-else class="white--text">
                  <v-col cols="12">
                    <strong class="display-1 font-weight-bold">
                      {{ volume.valor }}
                      <span class="font-weight-thin title">hm³
                    </span>
                    </strong>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-bind="hydrologicalCardColumns">
            <v-card class="primary darken-1">
              <v-row class="ml-2">
                <v-col cols="12" class="ml-0 mr-2">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                  <span v-if="volume" style="color: lightgrey; font-size: small">Atualizado em {{ volume.data }}</span>
                  <span v-else style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="secondary" class="mb-2">
                  mdi-database-check-outline
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">
                Volume Disponível
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon size="medium" right v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                  </template>
                  <span>Volume total menos volume morto</span>
                </v-tooltip>
              </v-card-subtitle>
              <v-card-text>
                <v-row v-if="!volume">
                  <v-col cols="3">
                    <v-icon color="orange" right>mdi-information-outline</v-icon>
                  </v-col>
                  <v-spacer/>
                  <v-col cols="9">
                    <span style="color: orange">Os dados do volume disponível estão indisponíveis no momento.</span>
                  </v-col>
                </v-row>
                <v-row v-else class="white--text">
                  <v-col cols="12">
                    <strong class="display-1 font-weight-bold">
                      {{ volumeDisponivel }}
                      <span class="font-weight-thin title">hm³
                    </span>
                    </strong>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col v-bind="hydrologicalCardColumns">
            <v-card class="primary darken-1">
              <v-row class="ml-1">
                <v-col cols="12" class="ml-1">
                  <v-icon style="color: lightgrey" left small>restore</v-icon>
                  <span v-if="currentQuota" style="color: lightgrey; font-size: small">Atualizado em {{ Formattdate(currentQuota.data) }}</span>
                  <span v-else style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
                </v-col>
              </v-row>
              <v-card-title class="mt-n5">
                <v-icon color="secondary" class="mb-2">
                  mdi-arrow-expand-vertical
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="font-weight-bold white--text">Cota atual</v-card-subtitle>
              <v-card-text>
                <v-row v-if="!currentQuota">
                  <v-col cols="3">
                    <v-icon color="orange" right>mdi-information-outline</v-icon>
                  </v-col>
                  <v-spacer/>
                  <v-col cols="9">
                    <span style="color: orange">Os dados de cota estão indisponíveis no momento.</span>
                  </v-col>
                </v-row>
                <v-row v-else class="white--text">
                  <v-col cols="12">
                    <strong class="display-1 font-weight-bold" v-if="currentQuota.valor">
                      {{ currentQuota.valor.toFixed(3) }}
                      <span class="font-weight-thin title">m
                        <span class="subtitle-1" style="color: orange" v-if="verifyAlert(currentQuota.valor)">
                          <v-icon color="orange" right>mdi-information-outline</v-icon>
                        <span> Abaixo do normal</span>
                      </span>
                    </span>
                    </strong>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="hidden-sm-and-down" cols="12" sm="12" md="3">
        <v-card class="primary darken-1 last">
          <v-row class="ml-1">
            <v-col cols="12" v-if="accumulatedRainOfMonth" class="ml-0 mr-2">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span style="color: lightgrey; font-size: small">Atualizado em {{ accumulatedRainOfMonth.updated }}</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary" class="mb-2">
              mdi-weather-pouring
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Chuva do mês atual</v-card-subtitle>
          <v-card-text>
            <v-row v-if="typeof accumulatedRainOfMonth === 'undefined'">
              <v-col cols="3">
                <v-icon color="orange" right>mdi-information-outline</v-icon>
              </v-col>
              <v-spacer/>
              <v-col cols="9">
                <span style="color: orange">Os dados de chuva estão indisponíveis no momento.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col cols="12">
                <strong class="display-1 font-weight-bold">
                  <span v-if="typeof accumulatedRainOfMonth.value === 'number'"> {{ accumulatedRainOfMonth.value.toFixed(1) }} </span>
                  <span v-else>{{ accumulatedRainOfMonth.value }}</span>
                  <span class="font-weight-thin title">mm
                  <span class="subtitle-2"> Acumulado do mês de {{ currentMonth }}</span>
                </span>
                </strong>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ['accumulatedRainOfMonth', 'currentMonth', 'currentQuota', 'volume', 'usefulStorage', 'reservoirSelected'],
  name: "PrecipitationDataContributionBasinCards",
  computed: {
    isMiringuava() {
      return this.reservoirSelected.codigo === 25644908;
    },
    hydrologicalCardColumns() {
      return {
        cols: 12,
        sm: 6,
        md: this.isMiringuava ? 6 : 4,
        lg: this.isMiringuava ? 3 : 4,
      };
    },
    volumeDisponivel(){
      return (!isNaN(parseFloat(this.reservoirSelected["VOLUME_RESERVA_TECNICA"])) && this.volume) ? (this.volume.valor - this.reservoirSelected["VOLUME_RESERVA_TECNICA"]).toFixed(3) : this.volume.valor;
    }
  },
  methods:{
    formatNumber(value) {
      return Number(value).toFixed(1);
    },
    Formattdate(val){
      return  val ? moment(val, 'YYYY-MM-DD').tz('America/Sao_Paulo').format('DD/MM/YYYY') : "##/##/####"
    },
    verifyAlert(value){
      let alertValue = this.$store.getters.alertCota
      if(value <= alertValue){
        return true
      } else{
        return false
      }
    }
  }
}
</script>

<style scoped>
.last.v-card.v-sheet.theme--dark {
  min-height: 175px;
  min-width: 220px;
  height: 100%;
  max-width: 1000px;
}
.v-card.v-sheet.theme--dark {
  min-height: 175px;
  min-width: 220px;
  height: 100%;
  max-width: 500px;
}
.useful-storage-cards .v-card.v-sheet.theme--dark {
  min-width: 0;
}
</style>
